import { render, staticRenderFns } from "./PackageCustomersLayout.vue?vue&type=template&id=a6d68f2c"
import script from "./PackageCustomersLayout.vue?vue&type=script&lang=js"
export * from "./PackageCustomersLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports